import React from 'react';
import classnames from 'classnames';
import Icon from './icons/Icon';
import LoadingPanel from './LoadingPanel';

class ActionButton extends React.Component {

    render = () => {
        const { title, icon, label, to, action, children, className, active = true, loading = false } = this.props;
        const mainClass = classnames("button", className, { 'inactive': !active });
        const onClick = active ? action : null;
        const href = active && action ? null : to;
        return (
            <a href={href} className={mainClass} onClick={onClick} >
                {loading && <LoadingPanel small={true} />}
                {icon && <Icon name={icon} inline={true} className="action-icon" />}
                {title}
                {children}
                {label && <span className="label">{label}</span>}
            </a>
        )
    };
}

export default ActionButton;